// extracted by mini-css-extract-plugin
export var checkbox = "_5n-0";
export var circle = "_5n-3";
export var horizontalContainer = "_5n-7";
export var sm = "_5n-5";
export var switch0 = "_5n-2";
export var switchDisabled = "_5n-8";
export var switchEnabled = "_5n-1";
export var textSwitchContainer = "_5n-9";
export var textSwitchOption = "_5n-a";
export var textSwitchOptionSelected = "_5n-b";
export var verticalContainer = "_5n-6";
export var xs = "_5n-4";